module.exports = __webpack_public_path__ + "media/images/faces/face4-646fdc952162e3157afea6d7931fb41c.jpg";